import { Event } from '@amzn/red-velvet-api';

export const EVENT_DATE_DISPLAY_WITH_MONTH_DAY_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

export function generateEventStartDateWithMonthAndDayToDisplay(
  selectedTimezone: string | null,
  language: string,
  event: Event
) {
  return event.startTimestamp?.toLocaleDateString(language, {
    ...EVENT_DATE_DISPLAY_WITH_MONTH_DAY_OPTIONS,
    timeZone: selectedTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}

export function generateEventEndDateWithMonthAndDayToDisplay(
  selectedTimezone: string | null,
  language: string,
  event: Event
) {
  return event.endTimestamp?.toLocaleDateString(language, {
    ...EVENT_DATE_DISPLAY_WITH_MONTH_DAY_OPTIONS,
    timeZone: selectedTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}

export function isSameDayFullDay(start: Date, end: Date): boolean {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const isSameDay =
    startDate.getUTCFullYear() === endDate.getUTCFullYear() &&
    startDate.getUTCMonth() === endDate.getUTCMonth() &&
    startDate.getUTCDate() === endDate.getUTCDate();
  const isFullDay =
    startDate.getUTCHours() === 0 &&
    startDate.getUTCMinutes() === 0 &&
    startDate.getUTCSeconds() === 0 &&
    endDate.getUTCHours() === 23 &&
    endDate.getUTCMinutes() === 59 &&
    endDate.getUTCSeconds() === 0;

  return isSameDay && isFullDay;
}

export function isUnlistedEvent(event: Event): boolean {
  return (
    event.source === 'VC' &&
    !!event.startTimestamp &&
    !!event.endTimestamp &&
    isSameDayFullDay(event.startTimestamp, event.endTimestamp) &&
    event.status !== 'DRAFT' // avoid confusion with listed events in draft
  );
}
